export default __webpack_public_path__ + "static/media/5.6ca91d92.png";